import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {UntypedFormBuilder, FormGroup, Validators, FormArray} from '@angular/forms';
import {FrtAccessorialsMasterService} from '../../services/frt-accessorials-master/frt-accessorials-master.service';
import {FrtShipmentAccessorialAdditionalInfoComponent} from '../frt-shipment-accessorial-additionalinfo/frt-shipment-accessorial-additionalinfo.component';
import {BsModalService, BsModalRef} from 'ngx-bootstrap/modal';
import {FrtShipmentsAccessorials} from './frt-accessorials';
import {FrtShipAccessorialsService} from '../../services/frt-ship-accessorials/frt-ship-accessorials.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FrtShipmentAccessorialAdditionalInfoService } from 'src/app/services/frt-shipment-accessorial-additionalinfo/frt-book-ship-accessorials-additionalinfo.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import {Units} from './units';
import { Location } from '@angular/common';
import { LoadingService } from 'src/app/services/loading/loading.service';
import AppConstants from 'src/app/shared/common-components/AppConstants';
import { BehaviorSubject } from 'rxjs';
import { takeWhile } from 'rxjs';
import { UserService } from '../../services/user/user.service';
import { FrtShopRatesIn, FrtAccesorial } from 'src/app/shared/common-components/common-structure';
import { CommonValidators } from '../../shared/common-components/common-validators';
import { HhgOnlineBookShipmentService } from '../hhg-online-book-shipment/hhg-online-book-shipment.service';

@Component({
    selector: 'app-frt-shipment-accessorials',
    templateUrl: './frt-shipment-accessorials.component.html',
    styleUrls: ['./frt-shipment-accessorials.component.css'],
    standalone: false
})
export class FrtShipmentAccessorialsComponent implements OnInit, OnDestroy {

  @Input() accessorialsCalledFrom: string;
  @Input() shipmentInfoIdFromUrl: any;
  private observer$ = new BehaviorSubject(true);
  isCarrierView = false;
  frtShipmentAccessorialForm: FormGroup;
  validationMessages: any;
  accessorialList: any;
  drnSuffix: any;
  isUnitsIdNine = false;
  acc: any;
  shipmentsId: any;
  shipperAuthorization: String[] = [
    'Authorized',
    'Pending',
    'Cancelled',
    'Rejected'
  ];
  tspAuthorization: String[] = [
    'Accepted',
    'Qualified'
  ];
  bsModalRef: BsModalRef;
  existingAccessorials: any;
  finalAccArray: FrtShipmentsAccessorials[] = [];
  existingMessages: any[];
  messageArray = [];
  accObj: any;
  arrIndex: number;
  checkFlag: boolean;
  additionalMessageResponse: any;
  redirectedFromBol: boolean;
  zeroAccessorialCount: boolean;
  accessorialCost: number;
  currentShipmentInfo: any;
  bookShipmentId: number;
  isOneTimeShipment: string;

  shipmentDetailsData: any;
  showAccessorialsError: boolean;

  constructor(private formBuilder: UntypedFormBuilder, private frtAccessorialsMasterService: FrtAccessorialsMasterService, private modalService: BsModalService,
    private frtShipAccessorialService: FrtShipAccessorialsService, private route: ActivatedRoute, private router: Router,
    private frtShipmentAccessorialsAdditionalInfoService: FrtShipmentAccessorialAdditionalInfoService, private userService: UserService,
    private alertService: AlertService, private loader: LoadingService, private location: Location,
    private bookShipmentService: HhgOnlineBookShipmentService) {
  }

  ngOnInit() {
    this.frtShipmentAccessorialForm = this.formBuilder.group({
      accessorials: this.formBuilder.array([])
    });
    this.existingAccessorials = [];
    window.scrollTo(0, 0);
    this.route.queryParams.subscribe(params => {
      this.shipmentsId = params['shipmentsId'];
      this.bookShipmentId = params['bookshipmentid'];
      this.isOneTimeShipment = params['oto'];
    });

    if (this.accessorialsCalledFrom === 'bol') {
      this.redirectedFromBol = true;
      this.shipmentsId = this.shipmentInfoIdFromUrl;
    } else {
      this.redirectedFromBol = false;
    }

    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
        this.loadCarrierView(currentUser);
      }, (error) => {
        this.loader.hide();
      });

    this.getAccessorialList();

    if (this.bookShipmentId !== undefined) {
      this.loader.show();
      this.bookShipmentService.getShipmentInfoByBookShipmentId(this.bookShipmentId).
        subscribe(data => {
          this.shipmentDetailsData = data;
          this.loader.hide();
        }, error => {
          this.loader.hide();
        });
      }
  }

  getAccessorialList() {
    this.loader.show();
    this.frtAccessorialsMasterService.getAll().subscribe(accessorials => {
      this.accessorialList = accessorials;
    }, (error) => {
      this.loader.hide();
      this.alertService.error('Error retrieving master accessorial list');
    }, () => {
      this.loadExisting();
    });
  }

  loadCarrierView(currentUser) {
    if (AppConstants.isNotNullCondition(currentUser)) {
      const carrierRoles = AppConstants.getCarrierRolesArray();
      if (currentUser.roles.some(role => carrierRoles.indexOf(role.name) >= 0)) {
        this.isCarrierView = true;
      }
    }
  }

  onAccessorialChange(event, index) {
    this.isNameDuplicate(index);
    const accessorial = this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].accessorial.value;
    const isAccessorialPresent = false;
    const accessorials = this.frtShipmentAccessorialForm.get('accessorials') as FormArray;

    this.frtAccessorialsMasterService.getUnitsDescriptionById(accessorial.unitsId).subscribe((units: Units) => {
      if (units !== null && units !== undefined) {
        this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].unitDescription.setValue(units.userDisplay);
        this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].amount.setValue(null);
        this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].amount.enable();
      }
      if (accessorial.unitsId === 9) {
        this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].amount.clearValidators();
        this.isUnitsIdNine = true;
      } else {
        this.isUnitsIdNine = false;
        this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].amount.setValidators([Validators.required, Validators.min(1), CommonValidators.currency]);
      }
      this.frtShipmentAccessorialForm.updateValueAndValidity();
    }, error => {
      this.alertService.error('Error while getting units description. please contact system administrator.');
    }, () => {
      if (this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].unitDescription.value === null) {
        this.onShipAuthorizationChange(index);
      }
    });

    this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].shipAuthorize.setValue('Authorized');
    if (this.isCarrierView) {
      this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].shipAuthorize.setValue('Pending');
    }
    this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].shipAuthorize.disable();

  }

  isNameDuplicate(index) {
    const existingAcc = this.existingAccessorials.map( x => {
      if (AppConstants.isNotNullCondition(x.frtAccessorialsMasterEntity) && AppConstants.isNotNullCondition(x)) {
        if (AppConstants.isNotNullCondition(x.usage)) {
          return (x.frtAccessorialsMasterEntity.accessorialDescription + ' - ' + x.usage).replace(/ /g, '-').toUpperCase();
        } else if (x.usage === null) {
          return (x.frtAccessorialsMasterEntity.accessorialDescription).replace(/ /g, '-').toUpperCase();
        }
      }
    });
    const accessorials = this.frtShipmentAccessorialForm.get('accessorials').value;
    if (accessorials.length !== 0) {
      const accessorialDescriptions = accessorials.map(item => item.accessorial ? item.accessorial.accessorialDescription.replace(/ /g, '-').toUpperCase() : null);
      const selectedAccesorial = accessorialDescriptions[accessorialDescriptions.length - 1];
      const hasDuplicate = existingAcc.some(
        (element) => element  === selectedAccesorial
      );
      const duplications = this.isArrayConsistsDuplicates(existingAcc);
      if (hasDuplicate || duplications) {
        this.showAccessorialsError = true;
        this.frtShipmentAccessorialForm.get('accessorials').setErrors({'incorrect': true});
      } else {
        this.showAccessorialsError = false;
        this.frtShipmentAccessorialForm.get('accessorials').setErrors(null);
      }
    }
  }

  /**
   * @description checks if the array has duplications by converting it into a set
   */
  isArrayConsistsDuplicates(array) {
    return (new Set(array)).size !== array.length;
  }


  onShipAuthorizationChange(index) {
   if (!(this.frtShipmentAccessorialForm.get('accessorials') as FormArray).at(index).get('units').hasError('numeric')) {
    if (this.isOneTimeShipment === 'false') {
      const selectedAccessorial = this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].accessorial.value;
      const accArray = [];
      const inputPayload = new FrtShopRatesIn();
      inputPayload.estimatedMileage = this.shipmentDetailsData.miles;
      inputPayload.estimatedWeight = this.shipmentDetailsData.weight;
      const accObj = new FrtAccesorial;
      accObj.frtAccessorialId = selectedAccessorial.frtAccessorialsId;
      if (selectedAccessorial.unitsId === 9) {
        accObj.estimatedCost = this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].units.value;
        accObj.quantity = null;
      } else {
        accObj.quantity = this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].units.value;
        accObj.estimatedCost = null;
      }
      accArray.push(accObj);
      inputPayload.accessorials = accArray;
      this.loader.show();
      this.frtShipAccessorialService.getAccessorialsCost(this.shipmentsId, inputPayload).subscribe(data => {
        if (data != null) {
          this.accessorialCost = data.accessorialCost;
          this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].amount.setValue(data.accessorialCost);
          this.frtShipmentAccessorialForm.get('accessorials')['controls'][index]['controls'].amount.disable();
        }
        this.loader.hide();
      }, (error) => {
        this.loader.hide();
        this.alertService.error('Error calculating accessorials cost');
      });
    }
  }
  }

  /**
   * @description Create new accessorial form group
   */
  createNewAccessorial(): FormGroup {
    const formGroup = this.formBuilder.group({
      accessorial: [null, [Validators.required]],
      units: [null, [CommonValidators.numeric]],
      unitDescription: [null],
      amount: [null],
      shipAuthorize: [null, [Validators.required]],
      tspAuthorize: [null, []]
    });
    formGroup.get('accessorial').valueChanges.subscribe(accessorial => {
      this.frtAccessorialsMasterService.getUnitsDescriptionById(accessorial.unitsId).subscribe((units: Units) => {
        if (units) {
          formGroup.get('accessorial').value.units = units;
          if (units.quantityRequired) {
            if (accessorial.unitsId !== 9) {
              formGroup.get('units').setValidators([Validators.required, CommonValidators.numeric,
                Validators.max(units.maxQuantity), Validators.min(units.minQuantity)]);
            } else {
              formGroup.get('units').setValidators([Validators.required,
                Validators.max(units.maxQuantity), Validators.min(units.minQuantity)]);
            }
          }
        } else {

        }
      });
    });
    return formGroup;
  }

  /**
   * @description To add accessorial
   */
  addAccessorial() {
    (this.frtShipmentAccessorialForm.get('accessorials') as FormArray).insert(0, this.createNewAccessorial());
  }

  /**
   * @description Remove accessorial from the forum at specified index
   * @param i
   */
  removeAccessorial(i, accessorialObj) {
    const accArray = this.frtShipmentAccessorialForm.get('accessorials') as FormArray;
    accessorialObj = accArray.controls[i].get('accessorial').value;
    (this.frtShipmentAccessorialForm.get('accessorials') as FormArray).removeAt(i);
    let accId = 0;
    if (this.existingAccessorials != null) {
      for (let i = 0; i < this.existingAccessorials.length; i++) {
        if (this.existingAccessorials[i].frtAccessorialsId == accessorialObj.frtAccessorialsId) {
          if (this.existingAccessorials[i].usage === null) {
            accId = this.existingAccessorials[i].shipmentAccrlsId;
          } else if (AppConstants.isNotNullCondition(this.existingAccessorials[i].usage) &&
            accessorialObj.accessorialDescription.endsWith(this.existingAccessorials[i].usage)) {
              accId = this.existingAccessorials[i].shipmentAccrlsId;
            }
        if (accId > 0) {
          this.loader.show();
          this.frtShipAccessorialService.deleteByAccessorialsById(accId).subscribe(deletedAcc => {
          }, (error) => {
            this.loader.hide();
            this.alertService.error('There was an error deleting accessorials!');
          }, () => {
            this.alertService.success('Successfully deleted accessorials');
            this.existingAccessorials.splice(i, 1);
            this.loader.hide();
          });
        }
      }
    }
  }
    this.isNameDuplicate(i);
  }

  /**
   * @description Validation message for Units
   * @param i
   */
  validateUnits(i) {

    if ((this.frtShipmentAccessorialForm.get('accessorials') as FormArray).at(i).get('accessorial').value) {
      const accessorialMax = (this.frtShipmentAccessorialForm.get('accessorials') as FormArray).at(i).get('accessorial').value.rangeTo;
      const accessorialMin = (this.frtShipmentAccessorialForm.get('accessorials') as FormArray).at(i).get('accessorial').value.rangeFrom;
      if ((this.frtShipmentAccessorialForm.get('accessorials') as FormArray).at(i).get('units').hasError('required')) {
        return 'Quantity Required';
      } else if ((this.frtShipmentAccessorialForm.get('accessorials') as FormArray).at(i).get('units').hasError('max')) {
        return 'Quantity Must be less than ' + accessorialMax;
      } else if ((this.frtShipmentAccessorialForm.get('accessorials') as FormArray).at(i).get('units').hasError('min')) {
        return 'Quentity Must be greater than ' + accessorialMin;
      } else {
        return null;
      }
    }
  }

  /**
   * @description - Open modal for adding new messages and Viewing message history
   * @param accessorialCode
   */

  openAdditionalInfo(i) {
    const accArray = this.frtShipmentAccessorialForm.get('accessorials') as FormArray;
    const accessorialObj = accArray.controls[i].get('accessorial').value;
    let accId = accessorialObj.frtAccessorialsId;
    if (this.existingAccessorials != null) {
      for (let i = 0; i < this.existingAccessorials.length; i++) {
        if (this.existingAccessorials[i].frtAccessorialsId == accessorialObj.frtAccessorialsId) {
          accId = this.existingAccessorials[i].shipmentAccrlsId;
        }
      }
    }
    if (accId == 0) {
      accId = accessorialObj.frtAccessorialsId;
    }

    this.frtShipmentAccessorialsAdditionalInfoService.getMessagesByAccessorialsId(accId).subscribe(existing => {
		  if (existing != null) {
        this.existingMessages = [];
        for (let i = 0; i < existing.length; i++) {
          this.existingMessages.push(existing[i].message);
        }
      }
      const initialState = {
        redirectedFromBol: this.redirectedFromBol
      };
      this.bsModalRef = this.modalService.show(FrtShipmentAccessorialAdditionalInfoComponent, { initialState });
      this.bsModalRef.content.action.subscribe((message) => {
        this.messageArray.push(message);
        this.existingMessages.push(message.message);
      });

      for(let aMessage of this.messageArray){
        if(aMessage.shipmentAccrlsId === accId){
          this.existingMessages.push(aMessage.message);
        }
      }
      const accessorialCode = accessorialObj.accessorialCode + ' - ' + accessorialObj.accessorialDescription;
      this.bsModalRef.content.title = accessorialCode;
      this.bsModalRef.content.shipmentsId = this.shipmentsId;
      this.bsModalRef.content.accId = accId;
      this.bsModalRef.content.messageHistoryArray = this.existingMessages;
		}, (error) => {
		}, () => {

    });



  }

  /**
   * @description Navigation to audit trail
   */
  viewAuditTrail() {
    this.router.navigate(['/', 'shipmentaudit'],  { queryParams: { shipmentId: this.shipmentsId }});
  }

  /**
   * @description Save Accessorial
   */
  saveAccessorial() {
    this.loader.show();
    const accArray = this.frtShipmentAccessorialForm.get('accessorials') as FormArray;
    this.finalAccArray = [];
    for (let i = 0; i < accArray.length; i++) {
      this.accObj = accArray.controls[i].get('accessorial').value;
      const frtId = this.accObj.frtAccessorialsId;
      if (this.existingAccessorials != null) {
        this.checkFlag = false;
        for (let n = 0; n < this.existingAccessorials.length; n++) {
          const frtId2 = this.existingAccessorials[n].frtAccessorialsId;
          if ( frtId2 === frtId) {
            if((AppConstants.isNotNullCondition(this.existingAccessorials[n].usage) &&
              this.accObj.accessorialDescription.endsWith(this.existingAccessorials[n].usage)) ||
              (this.existingAccessorials[n].usage === null
                && this.accObj.accessorialDescription === this.existingAccessorials[n].frtAccessorialsMasterEntity.accessorialDescription)){
                this.arrIndex = n;
                this.checkFlag = true;
            }
          }
        }
      }
      if (this.checkFlag == true) {
        this.acc = this.existingAccessorials[this.arrIndex];
        this.accObj = accArray.controls[i].get('accessorial').value;
        this.acc.shipmentsId = this.shipmentsId;
        this.acc.shipperRequest = accArray.controls[i].get('shipAuthorize').value;
        this.acc.tspRequest = accArray.controls[i].get('tspAuthorize').value;
        this.acc.frtAccessorialsId = this.accObj.frtAccessorialsId;
        if (this.accObj.unitsId === 9) {
          this.acc.estimatedCost = accArray.controls[i].get('units').value;
          this.acc.quantity = null;
          this.acc.accessorialCost = accArray.controls[i].get('units').value;
        } else {
          this.acc.quantity = accArray.controls[i].get('units').value;
          this.acc.estimatedCost = null;
          this.acc.accessorialCost = accArray.controls[i].get('amount').value;
        }
      } else {
        this.acc = new FrtShipmentsAccessorials;
        this.accObj = accArray.controls[i].get('accessorial').value;
        this.acc.shipmentsId = this.shipmentsId;
        this.acc.shipperRequest = accArray.controls[i].get('shipAuthorize').value;
        this.acc.tspRequest = accArray.controls[i].get('tspAuthorize').value;
        this.acc.frtAccessorialsId = this.accObj.frtAccessorialsId;
        if (this.accObj.unitsId === 9) {
          this.acc.estimatedCost = accArray.controls[i].get('units').value;
          this.acc.quantity = null;
          this.acc.accessorialCost = accArray.controls[i].get('units').value;
        } else {
          this.acc.quantity = accArray.controls[i].get('units').value;
          this.acc.estimatedCost = null;
          this.acc.accessorialCost = accArray.controls[i].get('amount').value;
        }
      }
      if (this.accObj.accessorialDescription.endsWith('Pickup')) {
        this.acc.usage = 'Pickup';
      } else if (this.accObj.accessorialDescription.endsWith('Delivery')) {
        this.acc.usage = 'Delivery';
      }
      this.acc.shipmentsId = this.shipmentsId;
      this.finalAccArray.push(this.acc);
    }

    this.frtShipAccessorialService.saveOrUpdateFrtAccessorials(this.finalAccArray).subscribe(access => {
      this.finalAccArray = access;
    }, (error) => {
      this.loader.hide();
      this.alertService.error('There was an error saving accessorials!');
    }, () => {
      this.existingAccessorials = this.finalAccArray;
      if (this.messageArray != null && this.messageArray.length > 0) { // Save Acc Messages
        this.addMessages(this.finalAccArray, this.messageArray);
        this.frtShipmentAccessorialsAdditionalInfoService.saveOrUpdateAccessorialMessages(this.messageArray).subscribe(response => {
          this.additionalMessageResponse = response;
          this.messageArray.length = 0;
            }, (error) => {
              this.loader.hide();
              this.alertService.error('Error while saving Accessorial Messages');
            }, () => {
              this.loader.hide();
              this.alertService.success('Successfully saved accessorials');
              this.location.back();
            });
      } else {
        this.loader.hide();
        this.alertService.success('Successfully saved accessorials');
        this.location.back();
      }
    });
  }
  addMessages(finalAccArray: FrtShipmentsAccessorials[], messageArray: any[]) {
    for (let i = 0; i < messageArray.length; i++) {
      for (let j = 0; j < finalAccArray.length; j++) {
        if (messageArray[i].shipmentAccrlsId === finalAccArray[j].frtAccessorialsId) {
          messageArray[i].shipmentAccrlsId = finalAccArray[j].shipmentAccrlsId;
        }
      }
    }
  }

  checkAccessorialList(accObj) {
    for (let i = 0; i < this.accessorialList.length; i++) {
      if (accObj.frtAccessorialsId == this.accessorialList[i].frtAccessorialsId) {
        if (accObj.usage === null) {
        return i;
        } else if (AppConstants.isNotNullCondition(accObj.usage) &&
        this.accessorialList[i].accessorialDescription.indexOf(accObj.usage) >= 0) {
          return i;
        }
      }
    }
  }
  loadExisting() {
    this.frtShipAccessorialService.findByShipment(this.shipmentsId).subscribe(access => {
      this.existingAccessorials = access;
      if (access.length === 0 || access === null) {
        this.zeroAccessorialCount = true;
      }
      if (this.existingAccessorials != null) {
        for (let i = 0; i < this.existingAccessorials.length; i++) {
          const index = this.checkAccessorialList(this.existingAccessorials[i]);
          const formGroup = this.formBuilder.group({
            accessorial: [{value: this.accessorialList[index], disabled: true}, []],
            units: [{value: this.accessorialList[index].unitsId === 9 ? this.existingAccessorials[i].accessorialCost : this.existingAccessorials[i].quantity, disabled: true}, []],
            unitDescription: [null],
            amount: [{value: this.existingAccessorials[i].accessorialCost, disabled: true}],
            shipAuthorize: this.existingAccessorials[i].shipperRequest,
            tspAuthorize: this.existingAccessorials[i].tspRequest,
            usage: this.existingAccessorials[i].usage
          });
          if (this.accessorialsCalledFrom === 'bol') {
            formGroup.get('accessorial').disable();
            formGroup.get('units').disable();
            formGroup.get('unitDescription').disable();
            formGroup.get('amount').disable();
            formGroup.get('shipAuthorize').disable();
            formGroup.get('tspAuthorize').disable();
          }

          this.frtAccessorialsMasterService.getUnitsDescriptionById(this.accessorialList[index].unitsId).subscribe((units: Units) => {
            if (units !== null &&  units !== undefined) {
              formGroup.get('unitDescription').setValue(units.userDisplay);
              (this.frtShipmentAccessorialForm.get('accessorials') as FormArray).push(formGroup);
            } else {
              (this.frtShipmentAccessorialForm.get('accessorials') as FormArray).push(formGroup);
            }
          });
        }
      }
    }, (error) => {
      this.loader.hide();
      this.alertService.error('Error retrieving accessorials!');
    }, () => {
      this.loader.hide();
        if (this.accessorialsCalledFrom != 'bol') {
          this.alertService.success('Successfully retrieved accessorials!');
        }
    });
  }

  checkExisting(existingAcc, newAcc, accIndex) {
    if (existingAcc != null) {
      for (let i = 0; i < existingAcc.length; i++) {
        if (existingAcc[i].frtAccessorialsId ==  newAcc.controls[accIndex].get('frtAccessorialsId').value) {
            return i;
        }

      }
    }
    return 0;
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }
}
